import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'bas-tooltip-content',
	template: '<ng-content></ng-content>',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TooltipContentComponent {}
